import React, { useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { categoryAPI } from '../../api/category.api';
import { homeAPI } from '../../api/home.api';
import { useCartWishlist } from '../../context/CartWishlistContext';
import { useLanguage } from '../../context/LanguageContext';
import ProductGrid from '../../components/product/ProductGrid';
import Loader from '../../components/common/Loader';

const Category = () => {
  const { slug } = useParams();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const { addToCart, addToWishlist } = useCartWishlist();
  const { t } = useLanguage();
  const categoryKey = `category.${slug}`;
  const translatedCategory = t(categoryKey);
  const categoryTitle = translatedCategory !== categoryKey ? translatedCategory : slug.replace('-', ' ');

  const fetchProducts = useCallback(async () => {
    try {
      let data;
      try {
        data = await homeAPI.getCategoryItems(slug);
      } catch (err) {
        data = await categoryAPI.getProductsBySlug(slug);
      }
      const productsList = data?.items || data?.products || data?.data || data || [];
      setProducts(Array.isArray(productsList) ? productsList : []);
    } catch (error) {
      console.error('Error fetching category products:', error);
      setProducts([]);
    } finally {
      setLoading(false);
    }
  }, [slug]);

  useEffect(() => {
    fetchProducts();
  }, [fetchProducts]);

  if (loading) return <Loader />;

  return (
    <div style={{ padding: '20px' }}>
      <h1 style={{ textTransform: 'capitalize' }}>{categoryTitle}</h1>
      <ProductGrid
        products={products}
        onAddToCart={addToCart}
        onAddToWishlist={addToWishlist}
      />
    </div>
  );
};

export default Category;
